import React, { useState, useEffect, useRef, useMemo } from "react"
import { useQuery, useQueryClient } from "react-query"
import { fetchDeals } from "../../../services/main.service"
import Paginator from "../../composites/paginator"
import WithAuth from "../../hoc/with-auth"
import { LayoutWithSidebar } from "../../layouts/layout-with-sidebar.tsx"
import {
  Badge,
  Box,
  Flex,
  Table,
  Tbody,
  Td,
  Th,
  Thead,
  Tr,
  Text,
  Grid,
  GridItem,
  Button,
  Input,
  IconButton,
  Link as Clink,
  Tabs,
  TabList,
  Tab,
} from "@chakra-ui/react"
import _ from "lodash"
import BlockedLoader from "../../composites/blocked-loader"
import DateRangePicker from "../../composites/date-range-picker"
import { AiOutlineSearch } from "react-icons/ai"
import { InputWrapper } from "../../composites"
import { ReactSelect } from "../../composites/select"
import { SelectSymbols } from "../../composites/select-symbols"
import { CSVLink, CSVDownload } from "react-csv"
import { AiOutlineDownload } from "react-icons/ai"
import App from "../../../App"
import { app } from "../../../config"
import { formatDate } from "../../../utils"
import {
  getAllAccounts,
  getAllPositions,
  getAllSummaries,
  getConnections,
} from "../../../services/crm.service"
import { AgGridReact } from "ag-grid-react"

const ConnectionsPage = () => {
  const {
    data,
    isLoading,
    isError,
    isRefetching,
    isFetched,
    isFetchedAfterMount,
    refetch,
  } = useQuery(["connections"], () => getConnections(), {
    refetchInterval: 4000,
  })
  const [tabIndex, setTabIndex] = useState(0)

  const handleTabsChange = (index: any) => {
    setTabIndex(index)
  }

  const gridRef = useRef<any>() // Optional - for accessing Grid's API
  const [rowData, setRowData] = useState() // Set rowData to Array of Objects, one Object per Row

  // [{"login":1000,"balance":0,"equity":0,"credit":0,"margin_used":0,"margin_level":0,"margin_free":0,"group":null},{"login":1001,"balance":0,"equity":0,"credit":0,"margin_used":0,"margin_level":0,"margin_free":0,"group":null},
  // Each Column Definition results in one Column.
  // public string group { get; set; }

  const [columnDefs, setColumnDefs] = useState([
    { headerName: "Login", field: "login" },
    { headerName: "No of Connections", field: "connections" },
    {
      headerName: "IP Address",
      field: "address",
      cellRenderer: (params: any) => (
        <>
          {_.map(params.value.split(","), (_v) => {
            return (
              <>
                {_v} <br />
              </>
            )
          })}
        </>
      ),
    },
    { headerName: "Group", field: "group" },
    { headerName: "Type", field: "type" },
    {
      headerName: "Build",
      field: "build",
      cellRenderer: (params: any) => (
        <>
          {_.map(params.value.split(","), (_v) => {
            return (
              <>
                {_v} <br />
              </>
            )
          })}
        </>
      ),
    },
    {
      headerName: "Time",
      field: "time",
      cellRenderer: (params: any) => (
        <>
          {_.map(params.value.split(","), (_v) => {
            return (
              <>
                {_v} <br />
              </>
            )
          })}
        </>
      ),
    },
    {
      headerName: "Computer ID",
      field: "computerID",
      cellRenderer: (params: any) => (
        <>
          {_.map(params.value.split(","), (_v) => {
            return (
              <>
                {_v} <br />
              </>
            )
          })}
        </>
      ),
    },
  ])

  const [IPColumnDefs, setIpColumnDefs] = useState([
    { headerName: "Address", field: "address" },
    { headerName: "No of Connections", field: "connections" },
    {
      headerName: "Login",
      field: "login",
      cellRenderer: (params: any) => (
        <>
          {_.map(params.value.split(","), (_v) => {
            return (
              <>
                {_v} <br />
              </>
            )
          })}
        </>
      ),
    },
    {
      headerName: "Group",
      field: "group",
      cellRenderer: (params: any) => (
        <>
          {_.map(params.value.split(","), (_v) => {
            return (
              <>
                {_v} <br />
              </>
            )
          })}
        </>
      ),
    },
    {
      headerName: "Type",
      field: "type",
      cellRenderer: (params: any) => (
        <>
          {_.map(params.value.split(","), (_v) => {
            return (
              <>
                {_v} <br />
              </>
            )
          })}
        </>
      ),
    },
    {
      headerName: "Build",
      field: "build",
      cellRenderer: (params: any) => (
        <>
          {_.map(params.value.split(","), (_v) => {
            return (
              <>
                {_v} <br />
              </>
            )
          })}
        </>
      ),
    },
    {
      headerName: "Time",
      field: "time",
      cellRenderer: (params: any) => (
        <>
          {_.map(params.value.split(","), (_v) => {
            return (
              <>
                {_v} <br />
              </>
            )
          })}
        </>
      ),
    },
    {
      headerName: "Computer ID",
      field: "computerID",
      cellRenderer: (params: any) => (
        <>
          {_.map(params.value.split(","), (_v) => {
            return (
              <>
                {_v} <br />
              </>
            )
          })}
        </>
      ),
    },
  ])

  // DefaultColDef sets props common to all Columns
  const defaultColDef = useMemo(
    () => ({
      // make every column editable
      editable: false,
      selectable: true,
      // make every column use 'text' filter by default
      filter: "agTextColumnFilter",
      // enable floating filters by default
      floatingFilter: true,
      // make columns resizable
      resizable: true,
      // disable cell data types
      cellDataType: false,
      sortable: true,
    }),
    []
  )

  const formatData = useMemo(() => {
    let formattedData: any[] = []

    const groupedData = _.groupBy(
      data?.data?.data,
      tabIndex === 0 ? "login" : "address"
    )

    formattedData = _.map(groupedData, (_d, _login) => {
      if (tabIndex === 1) {
        return {
          login: _.map(_d, (d) => d?.login).join(","),
          connections: _d.length,
          address: _login,
          group: _.map(_d, (d) => d?.group).join(","),
          type: _.map(_d, (d) => d?.type?.split("_").reverse()[0]).join(","),
          build: _.map(_d, (d) => d?.build).join(","),
          time: _.map(_d, (d) => d?.time).join(","),
          computerID: _.map(_d, (d) => d?.computerID).join(","),
        }
      }

      return {
        login: _login,
        connections: _d.length,
        address: _.map(_d, (d) => d?.address).join(","),
        group: _d[0]?.group,
        type: _d[0]?.type?.split("_").reverse()[0],
        build: _.map(_d, (d) => d?.build).join(","),
        time: _.map(_d, (d) => d?.time).join(","),
        computerID: _.map(_d, (d) => d?.computerID).join(","),
      }
    })

    return formattedData
  }, [data?.data?.data, isLoading, tabIndex])

  return (
    <>
      <Tabs index={tabIndex} onChange={handleTabsChange}>
        <TabList>
          <Tab>Show by Login</Tab>
          <Tab>Show By IP Address</Tab>
        </TabList>
      </Tabs>

      <br />
      <div className="ag-grid-container">
        <div
          className="ag-theme-alpine"
          style={{ width: "100%", height: "calc(100vh - 100px)" }}
        >
          <AgGridReact
            suppressScrollOnNewData={true}
            ref={gridRef} // Ref for accessing Grid's API
            rowData={formatData ?? []} // Row Data for Rows
            columnDefs={tabIndex === 0 ? columnDefs : IPColumnDefs} // Column Defs for Columns
            defaultColDef={defaultColDef} // Default Column Properties
            animateRows={true} // Optional - set to 'true' to have rows animate when sorted
            overlayNoRowsTemplate={
              isLoading ? "Loading connections..." : "No connections found"
            }
            domLayout="autoHeight"
            getRowHeight={(params: any) => {
              if (tabIndex === 1) {
                return params?.data?.login?.split(",")?.length
                  ? params?.data?.login?.split(",")?.length * 40
                  : 40
              }

              return params?.data?.address?.split(",")?.length
                ? params?.data?.address?.split(",")?.length * 40
                : 40
            }}
          />
        </div>
      </div>
    </>
  )
}

export default ConnectionsPage
